import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

// utils
import idsMatch from 'utils/idsMatch'

export const BULK_REGENERATE_AGREEMENTS = 'sef/BULK_REGENERATE_AGREEMENTS'
export const BULK_REGENERATE_AGREEMENTS_FAILURE = 'sef/BULK_REGENERATE_AGREEMENTS_FAILURE'
export const BULK_REGENERATE_AGREEMENTS_SUCCESS = 'sef/BULK_REGENERATE_AGREEMENTS_SUCCESS'
export const BULK_REGENERATE_ARCHIVES = 'sef/BULK_REGENERATE_ARCHIVES'
export const BULK_REGENERATE_ARCHIVES_FAILURE = 'sef/BULK_REGENERATE_ARCHIVES_FAILURE'
export const BULK_REGENERATE_ARCHIVES_SUCCESS = 'sef/BULK_REGENERATE_ARCHIVES_SUCCESS'
export const BULK_UPLOAD_DOCUMENTS = 'sef/BULK_UPLOAD_DOCUMENTS'
export const BULK_UPLOAD_DOCUMENTS_FAILURE = 'sef/BULK_UPLOAD_DOCUMENTS_FAILURE'
export const BULK_UPLOAD_DOCUMENTS_SUCCESS = 'sef/BULK_UPLOAD_DOCUMENTS_SUCCESS'
export const FETCH_BULK_DOCUMENT_UPLOAD_STATUS = 'sef/FETCH_BULK_DOCUMENT_UPLOAD_STATUS'
export const FETCH_BULK_DOCUMENT_UPLOAD_STATUS_FAILURE =
  'sef/FETCH_BULK_DOCUMENT_UPLOAD_STATUS_FAILURE'
export const FETCH_BULK_DOCUMENT_UPLOAD_STATUS_SUCCESS =
  'sef/FETCH_BULK_DOCUMENT_UPLOAD_STATUS_SUCCESS'
export const RESET_BULK_DOCUMENT_UPLOAD = 'sef/RESET_BULK_DOCUMENT_UPLOAD'
export const BULK_REGENERATE_PAYSLIPS = 'sef/BULK_REGENERATE_PAYSLIPS'
export const BULK_REGENERATE_PAYSLIPS_FAILURE = 'sef/BULK_REGENERATE_PAYSLIPS_FAILURE'
export const BULK_REGENERATE_PAYSLIPS_SUCCESS = 'sef/BULK_REGENERATE_PAYSLIPS_SUCCESS'
export const CREATE_AGREEMENT_TEMPLATE = 'sef/CREATE_AGREEMENT_TEMPLATE'
export const CREATE_AGREEMENT_TEMPLATE_FAILURE = 'sef/CREATE_AGREEMENT_TEMPLATE_FAILURE'
export const CREATE_AGREEMENT_TEMPLATE_SUCCESS = 'sef/CREATE_AGREEMENT_TEMPLATE_SUCCESS'
export const CREATE_BUDGET = 'sef/CREATE_BUDGET'
export const CREATE_BUDGET_FAILURE = 'sef/CREATE_BUDGET_FAILURE'
export const CREATE_BUDGET_SUCCESS = 'sef/CREATE_BUDGET_SUCCESS'
export const CREATE_BUDGET_CATEGORY = 'sef/CREATE_BUDGET_CATEGORY'
export const CREATE_BUDGET_CATEGORY_FAILURE = 'sef/CREATE_BUDGET_CATEGORY_FAILURE'
export const CREATE_BUDGET_CATEGORY_SUCCESS = 'sef/CREATE_BUDGET_CATEGORY_SUCCESS'
export const CREATE_OUTPUT_AREA = 'sef/CREATE_OUTPUT_AREA'
export const CREATE_OUTPUT_AREA_FAILURE = 'sef/CREATE_OUTPUT_AREA_FAILURE'
export const CREATE_OUTPUT_AREA_SUCCESS = 'sef/CREATE_OUTPUT_AREA_SUCCESS'
export const CREATE_OUTPUT_INDICATOR = 'sef/CREATE_OUTPUT_INDICATOR'
export const CREATE_OUTPUT_INDICATOR_FAILURE = 'sef/CREATE_OUTPUT_INDICATOR_FAILURE'
export const CREATE_OUTPUT_INDICATOR_SUCCESS = 'sef/CREATE_OUTPUT_INDICATOR_SUCCESS'
export const CREATE_PARTNER = 'sef/CREATE_PARTNER'
export const CREATE_PARTNER_FAILURE = 'sef/CREATE_PARTNER_FAILURE'
export const CREATE_PARTNER_SUCCESS = 'sef/CREATE_PARTNER_SUCCESS'
export const CREATE_PARTNER_DISTRICT = 'sef/CREATE_PARTNER_DISTRICT'
export const CREATE_PARTNER_DISTRICT_FAILURE = 'sef/CREATE_PARTNER_DISTRICT_FAILURE'
export const CREATE_PARTNER_DISTRICT_SUCCESS = 'sef/CREATE_PARTNER_DISTRICT_SUCCESS'
export const CREATE_PAYFILE = 'sef/CREATE_PAYFILE'
export const CREATE_PAYFILE_FAILURE = 'sef/CREATE_PAYFILE_FAILURE'
export const CREATE_PAYFILE_SUCCESS = 'sef/CREATE_PAYFILE_SUCCESS'
export const CREATE_SUPPLIER = 'sef/CREATE_SUPPLIER'
export const CREATE_SUPPLIER_FAILURE = 'sef/CREATE_SUPPLIER_FAILURE'
export const CREATE_SUPPLIER_SUCCESS = 'sef/CREATE_SUPPLIER_SUCCESS'
export const CREATE_WORKSITE = 'sef/CREATE_WORKSITE'
export const CREATE_WORKSITE_FAILURE = 'sef/CREATE_WORKSITE_FAILURE'
export const CREATE_WORKSITE_SUCCESS = 'sef/CREATE_WORKSITE_SUCCESS'
export const CREATE_WORKSPACE = 'sef/CREATE_WORKSPACE'
export const CREATE_WORKSPACE_FAILURE = 'sef/CREATE_WORKSPACE_FAILURE'
export const CREATE_WORKSPACE_SUCCESS = 'sef/CREATE_WORKSPACE_SUCCESS'
export const CREATE_WORKSPACE_PROJECT = 'sef/CREATE_WORKSPACE_PROJECT'
export const CREATE_WORKSPACE_PROJECT_FAILURE = 'sef/CREATE_WORKSPACE_PROJECT_FAILURE'
export const CREATE_WORKSPACE_PROJECT_SUCCESS = 'sef/CREATE_WORKSPACE_PROJECT_SUCCESS'
export const DELETE_BUDGET_CATEGORY = 'sef/DELETE_BUDGET_CATEGORY'
export const DELETE_BUDGET_CATEGORY_FAILURE = 'sef/DELETE_BUDGET_CATEGORY_FAILURE'
export const DELETE_BUDGET_CATEGORY_SUCCESS = 'sef/DELETE_BUDGET_CATEGORY_SUCCESS'
export const DELETE_OUTPUT = 'sef/DELETE_OUTPUT'
export const DELETE_OUTPUT_FAILURE = 'sef/DELETE_OUTPUT_FAILURE'
export const DELETE_OUTPUT_SUCCESS = 'sef/DELETE_OUTPUT_SUCCESS'
export const DELETE_OUTPUT_AREA = 'sef/DELETE_OUTPUT_AREA'
export const DELETE_OUTPUT_AREA_FAILURE = 'sef/DELETE_OUTPUT_AREA_FAILURE'
export const DELETE_OUTPUT_AREA_SUCCESS = 'sef/DELETE_OUTPUT_AREA_SUCCESS'
export const DELETE_OUTPUT_INDICATOR = 'sef/DELETE_OUTPUT_INDICATOR'
export const DELETE_OUTPUT_INDICATOR_FAILURE = 'sef/DELETE_OUTPUT_INDICATOR_FAILURE'
export const DELETE_OUTPUT_INDICATOR_SUCCESS = 'sef/DELETE_OUTPUT_INDICATOR_SUCCESS'
export const DELETE_PARTNER_DISTRICT = 'sef/DELETE_PARTNER_DISTRICT'
export const DELETE_PARTNER_DISTRICT_FAILURE = 'sef/DELETE_PARTNER_DISTRICT_FAILURE'
export const DELETE_PARTNER_DISTRICT_SUCCESS = 'sef/DELETE_PARTNER_DISTRICT_SUCCESS'
export const DELETE_SUPPLIER = 'sef/DELETE_SUPPLIER'
export const DELETE_SUPPLIER_FAILURE = 'sef/DELETE_SUPPLIER_FAILURE'
export const DELETE_SUPPLIER_SUCCESS = 'sef/DELETE_SUPPLIER_SUCCESS'
export const DELETE_WORKSITE = 'sef/DELETE_WORKSITE'
export const DELETE_WORKSITE_FAILURE = 'sef/DELETE_WORKSITE_FAILURE'
export const DELETE_WORKSITE_SUCCESS = 'sef/DELETE_WORKSITE_SUCCESS'
export const DELETE_WORKSPACE = 'sef/DELETE_WORKSPACE'
export const DELETE_WORKSPACE_FAILURE = 'sef/DELETE_WORKSPACE_FAILURE'
export const DELETE_WORKSPACE_SUCCESS = 'sef/DELETE_WORKSPACE_SUCCESS'
export const DELETE_WORKSPACE_PROJECT = 'sef/DELETE_WORKSPACE_PROJECT'
export const DELETE_WORKSPACE_PROJECT_FAILURE = 'sef/DELETE_WORKSPACE_PROJECT_FAILURE'
export const DELETE_WORKSPACE_PROJECT_SUCCESS = 'sef/DELETE_WORKSPACE_PROJECT_SUCCESS'
export const DOWNLOAD_BULK_AGREEMENTS = 'sef/DOWNLOAD_BULK_AGREEMENTS'
export const DOWNLOAD_BULK_AGREEMENTS_FAILURE = 'sef/DOWNLOAD_BULK_AGREEMENTS_FAILURE'
export const DOWNLOAD_BULK_AGREEMENTS_SUCCESS = 'sef/DOWNLOAD_BULK_AGREEMENTS_SUCCESS'
export const FETCH_ACTIVITY_REPORTS = 'sef/FETCH_ACTIVITY_REPORTS'
export const FETCH_ACTIVITY_REPORTS_FAILURE = 'sef/FETCH_ACTIVITY_REPORTS_FAILURE'
export const FETCH_ACTIVITY_REPORTS_SUCCESS = 'sef/FETCH_ACTIVITY_REPORTS_SUCCESS'
export const FETCH_ADMINS = 'sef/FETCH_ADMINS'
export const FETCH_ADMINS_FAILURE = 'sef/FETCH_ADMINS_FAILURE'
export const FETCH_ADMINS_SUCCESS = 'sef/FETCH_ADMINS_SUCCESS'
export const FETCH_AGREEMENT_TEMPLATE = 'sef/FETCH_AGREEMENT_TEMPLATE'
export const FETCH_AGREEMENT_TEMPLATE_FAILURE = 'sef/FETCH_AGREEMENT_TEMPLATE_FAILURE'
export const FETCH_AGREEMENT_TEMPLATE_SUCCESS = 'sef/FETCH_AGREEMENT_TEMPLATE_SUCCESS'
export const FETCH_AGREEMENT_TEMPLATES = 'sef/FETCH_AGREEMENT_TEMPLATES'
export const FETCH_AGREEMENT_TEMPLATES_FAILURE = 'sef/FETCH_AGREEMENT_TEMPLATES_FAILURE'
export const FETCH_AGREEMENT_TEMPLATES_SUCCESS = 'sef/FETCH_AGREEMENT_TEMPLATES_SUCCESS'
export const FETCH_BUDGET = 'sef/FETCH_BUDGET'
export const FETCH_BUDGET_FAILURE = 'sef/FETCH_BUDGET_FAILURE'
export const FETCH_BUDGET_SUCCESS = 'sef/FETCH_BUDGET_SUCCESS'
export const FETCH_BUDGETS = 'sef/FETCH_BUDGETS'
export const FETCH_BUDGETS_FAILURE = 'sef/FETCH_BUDGETS_FAILURE'
export const FETCH_BUDGETS_SUCCESS = 'sef/FETCH_BUDGETS_SUCCESS'
export const FETCH_BUDGET_CATEGORIES = 'sef/FETCH_BUDGET_CATEGORIES'
export const FETCH_BUDGET_CATEGORIES_FAILURE = 'sef/FETCH_BUDGET_CATEGORIES_FAILURE'
export const FETCH_BUDGET_CATEGORIES_SUCCESS = 'sef/FETCH_BUDGET_CATEGORIES_SUCCESS'
export const FETCH_BUDGET_CATEGORY = 'sef/FETCH_BUDGET_CATEGORY'
export const FETCH_BUDGET_CATEGORY_FAILURE = 'sef/FETCH_BUDGET_CATEGORY_FAILURE'
export const FETCH_BUDGET_CATEGORY_SUCCESS = 'sef/FETCH_BUDGET_CATEGORY_SUCCESS'
export const FETCH_DISTRICTS = 'sef/FETCH_DISTRICTS'
export const FETCH_DISTRICTS_FAILURE = 'sef/FETCH_DISTRICTS_FAILURE'
export const FETCH_DISTRICTS_SUCCESS = 'sef/FETCH_DISTRICTS_SUCCESS'
export const FETCH_EMPLOYEE_DETAILS = 'sef/FETCH_EMPLOYEE_DETAILS'
export const FETCH_EMPLOYEE_DETAILS_FAILURE = 'sef/FETCH_EMPLOYEE_DETAILS_FAILURE'
export const FETCH_EMPLOYEE_DETAILS_SUCCESS = 'sef/FETCH_EMPLOYEE_DETAILS_SUCCESS'
export const FETCH_MUNICIPALITIES = 'sef/FETCH_MUNICIPALITIES'
export const FETCH_MUNICIPALITIES_FAILURE = 'sef/FETCH_MUNICIPALITIES_FAILURE'
export const FETCH_MUNICIPALITIES_SUCCESS = 'sef/FETCH_MUNICIPALITIES_SUCCESS'
export const FETCH_MUNICIPALITY = 'sef/FETCH_MUNICIPALITY'
export const FETCH_MUNICIPALITY_FAILURE = 'sef/FETCH_MUNICIPALITY_FAILURE'
export const FETCH_MUNICIPALITY_SUCCESS = 'sef/FETCH_MUNICIPALITY_SUCCESS'
export const FETCH_ONBOARDING_QUESTIONS = 'sef/FETCH_ONBOARDING_QUESTIONS'
export const FETCH_ONBOARDING_QUESTIONS_FAILURE = 'sef/FETCH_ONBOARDING_QUESTIONS_FAILURE'
export const FETCH_ONBOARDING_QUESTIONS_SUCCESS = 'sef/FETCH_ONBOARDING_QUESTIONS_SUCCESS'
export const FETCH_OUTPUT = 'sef/FETCH_OUTPUT'
export const FETCH_OUTPUT_FAILURE = 'sef/FETCH_OUTPUT_FAILURE'
export const FETCH_OUTPUT_SUCCESS = 'sef/FETCH_OUTPUT_SUCCESS'
export const FETCH_OUTPUT_AREA = 'sef/FETCH_OUTPUT_AREA'
export const FETCH_OUTPUT_AREA_FAILURE = 'sef/FETCH_OUTPUT_AREA_FAILURE'
export const FETCH_OUTPUT_AREA_SUCCESS = 'sef/FETCH_OUTPUT_AREA_SUCCESS'
export const FETCH_OUTPUT_AREAS = 'sef/FETCH_OUTPUT_AREAS'
export const FETCH_OUTPUT_AREAS_FAILURE = 'sef/FETCH_OUTPUT_AREAS_FAILURE'
export const FETCH_OUTPUT_AREAS_SUCCESS = 'sef/FETCH_OUTPUT_AREAS_SUCCESS'
export const FETCH_OUTPUT_INDICATOR = 'sef/FETCH_OUTPUT_INDICATOR'
export const FETCH_OUTPUT_INDICATOR_FAILURE = 'sef/FETCH_OUTPUT_INDICATOR_FAILURE'
export const FETCH_OUTPUT_INDICATOR_SUCCESS = 'sef/FETCH_OUTPUT_INDICATOR_SUCCESS'
export const FETCH_OUTPUT_INDICATORS = 'sef/FETCH_OUTPUT_INDICATORS'
export const FETCH_OUTPUT_INDICATORS_FAILURE = 'sef/FETCH_OUTPUT_INDICATORS_FAILURE'
export const FETCH_OUTPUT_INDICATORS_SUCCESS = 'sef/FETCH_OUTPUT_INDICATORS_SUCCESS'
export const FETCH_OUTPUTS = 'sef/FETCH_OUTPUTS'
export const FETCH_OUTPUTS_FAILURE = 'sef/FETCH_OUTPUTS_FAILURE'
export const FETCH_OUTPUTS_SUCCESS = 'sef/FETCH_OUTPUTS_SUCCESS'
export const FETCH_OWN_PROFILE_DETAILS = 'sef/FETCH_OWN_PROFILE_DETAILS'
export const FETCH_OWN_PROFILE_DETAILS_FAILURE = 'sef/FETCH_OWN_PROFILE_DETAILS_FAILURE'
export const FETCH_OWN_PROFILE_DETAILS_SUCCESS = 'sef/FETCH_OWN_PROFILE_DETAILS_SUCCESS'
export const FETCH_PARTICIPANT_PROFILE = 'sef/FETCH_PARTICIPANT_PROFILE'
export const FETCH_PARTICIPANT_PROFILE_FAILURE = 'sef/FETCH_PARTICIPANT_PROFILE_FAILURE'
export const FETCH_PARTICIPANT_PROFILE_SUCCESS = 'sef/FETCH_PARTICIPANT_PROFILE_SUCCESS'
export const FETCH_PARTNER = 'sef/FETCH_PARTNER'
export const FETCH_PARTNER_DISTRICT = 'sef/FETCH_PARTNER_DISTRICT'
export const FETCH_PARTNER_DISTRICT_FAILURE = 'sef/FETCH_PARTNER_DISTRICT_FAILURE'
export const FETCH_PARTNER_DISTRICT_SUCCESS = 'sef/FETCH_PARTNER_DISTRICT_SUCCESS'
export const FETCH_PARTNER_DISTRICTS = 'sef/FETCH_PARTNER_DISTRICTS'
export const FETCH_PARTNER_DISTRICTS_FAILURE = 'sef/FETCH_PARTNER_DISTRICTS_FAILURE'
export const FETCH_PARTNER_DISTRICTS_SUCCESS = 'sef/FETCH_PARTNER_DISTRICTS_SUCCESS'
export const FETCH_PARTNER_FAILURE = 'sef/FETCH_PARTNER_FAILURE'
export const FETCH_PARTNER_SUCCESS = 'sef/FETCH_PARTNER_SUCCESS'
export const FETCH_PARTNERS = 'sef/FETCH_PARTNERS'
export const FETCH_PARTNERS_FAILURE = 'sef/FETCH_PARTNERS_FAILURE'
export const FETCH_PARTNERS_SUCCESS = 'sef/FETCH_PARTNERS_SUCCESS'
export const FETCH_PAYROLL_BALANCE = 'sef/FETCH_PAYROLL_BALANCE'
export const FETCH_PAYROLL_BALANCE_FAILURE = 'sef/FETCH_PAYROLL_BALANCE_FAILURE'
export const FETCH_PAYROLL_BALANCE_SUCCESS = 'sef/FETCH_PAYROLL_BALANCE_SUCCESS'
export const FETCH_PAYROLL_HISTORY = 'sef/FETCH_PAYROLL_HISTORY'
export const FETCH_PAYROLL_HISTORY_FAILURE = 'sef/FETCH_PAYROLL_HISTORY_FAILURE'
export const FETCH_PAYROLL_HISTORY_SUCCESS = 'sef/FETCH_PAYROLL_HISTORY_SUCCESS'
export const FETCH_PAYROLL_PAYMENT_REQUEST = 'sef/FETCH_PAYROLL_PAYMENT_REQUEST'
export const FETCH_PAYROLL_PAYMENT_REQUEST_FAILURE = 'sef/FETCH_PAYROLL_PAYMENT_REQUEST_FAILURE'
export const FETCH_PAYROLL_PAYMENT_REQUEST_SUCCESS = 'sef/FETCH_PAYROLL_PAYMENT_REQUEST_SUCCESS'
export const FETCH_PAYROLL_PAYMENT_REQUESTS = 'sef/FETCH_PAYROLL_PAYMENT_REQUESTS'
export const FETCH_PAYROLL_PAYMENT_REQUESTS_FAILURE = 'sef/FETCH_PAYROLL_PAYMENT_REQUESTS_FAILURE'
export const FETCH_PAYROLL_PAYMENT_REQUESTS_SUCCESS = 'sef/FETCH_PAYROLL_PAYMENT_REQUESTS_SUCCESS'
export const FETCH_PLACE = 'sef/FETCH_PLACE'
export const FETCH_PLACE_FAILURE = 'sef/FETCH_PLACE_FAILURE'
export const FETCH_PLACE_SUCCESS = 'sef/FETCH_PLACE_SUCCESS'
export const FETCH_PLACES = 'sef/FETCH_PLACES'
export const FETCH_PLACES_FAILURE = 'sef/FETCH_PLACES_FAILURE'
export const FETCH_PLACES_SUCCESS = 'sef/FETCH_PLACES_SUCCESS'
export const FETCH_PROGRAMS = 'sef/FETCH_PROGRAMS'
export const FETCH_PROGRAMS_FAILURE = 'sef/FETCH_PROGRAMS_FAILURE'
export const FETCH_PROGRAMS_SUCCESS = 'sef/FETCH_PROGRAMS_SUCCESS'
export const FETCH_SCAFFOLD_DATA = 'sef/FETCH_SCAFFOLD_DATA'
export const FETCH_SCAFFOLD_DATA_FAILURE = 'sef/FETCH_SCAFFOLD_DATA_FAILURE'
export const FETCH_SCAFFOLD_DATA_SUCCESS = 'sef/FETCH_SCAFFOLD_DATA_SUCCESS'
export const FETCH_STATS = 'sef/FETCH_STATS'
export const FETCH_STATS_FAILURE = 'sef/FETCH_STATS_FAILURE'
export const FETCH_STATS_SUCCESS = 'sef/FETCH_STATS_SUCCESS'
export const FETCH_SUPPLIER = 'sef/FETCH_SUPPLIER'
export const FETCH_SUPPLIER_FAILURE = 'sef/FETCH_SUPPLIER_FAILURE'
export const FETCH_SUPPLIER_SUCCESS = 'sef/FETCH_SUPPLIER_SUCCESS'
export const FETCH_SUPPLIERS = 'sef/FETCH_SUPPLIERS'
export const FETCH_SUPPLIERS_FAILURE = 'sef/FETCH_SUPPLIERS_FAILURE'
export const FETCH_SUPPLIERS_SUCCESS = 'sef/FETCH_SUPPLIERS_SUCCESS'
export const FETCH_TIMEKEEPERS = 'sef/FETCH_TIMEKEEPERS'
export const FETCH_TIMEKEEPERS_FAILURE = 'sef/FETCH_TIMEKEEPERS_FAILURE'
export const FETCH_TIMEKEEPERS_SUCCESS = 'sef/FETCH_TIMEKEEPERS_SUCCESS'
export const FETCH_WARD = 'sef/FETCH_WARD'
export const FETCH_WARD_FAILURE = 'sef/FETCH_WARD_FAILURE'
export const FETCH_WARD_SUCCESS = 'sef/FETCH_WARD_SUCCESS'
export const FETCH_WARDS = 'sef/FETCH_WARDS'
export const FETCH_WARDS_FAILURE = 'sef/FETCH_WARDS_FAILURE'
export const FETCH_WARDS_SUCCESS = 'sef/FETCH_WARDS_SUCCESS'
export const FETCH_WORKSITE = 'sef/FETCH_WORKSITE'
export const FETCH_WORKSITE_FAILURE = 'sef/FETCH_WORKSITE_FAILURE'
export const FETCH_WORKSITE_SUCCESS = 'sef/FETCH_WORKSITE_SUCCESS'
export const FETCH_WORKSITES = 'sef/FETCH_WORKSITES'
export const FETCH_WORKSITES_FAILURE = 'sef/FETCH_WORKSITES_FAILURE'
export const FETCH_WORKSITES_SUCCESS = 'sef/FETCH_WORKSITES_SUCCESS'
export const FETCH_WORKSPACE = 'sef/FETCH_WORKSPACE'
export const FETCH_WORKSPACE_FAILURE = 'sef/FETCH_WORKSPACE_FAILURE'
export const FETCH_WORKSPACE_SUCCESS = 'sef/FETCH_WORKSPACE_SUCCESS'
export const FETCH_WORKSPACES = 'sef/FETCH_WORKSPACES'
export const FETCH_WORKSPACES_FAILURE = 'sef/FETCH_WORKSPACES_FAILURE'
export const FETCH_WORKSPACES_SUCCESS = 'sef/FETCH_WORKSPACES_SUCCESS'
export const FETCH_WORKSPACE_PROJECT = 'sef/FETCH_WORKSPACE_PROJECT'
export const FETCH_WORKSPACE_PROJECT_FAILURE = 'sef/FETCH_WORKSPACE_PROJECT_FAILURE'
export const FETCH_WORKSPACE_PROJECT_SUCCESS = 'sef/FETCH_WORKSPACE_PROJECT_SUCCESS'
export const FETCH_WORKSPACE_PROJECTS = 'sef/FETCH_WORKSPACE_PROJECTS'
export const FETCH_WORKSPACE_PROJECTS_FAILURE = 'sef/FETCH_WORKSPACE_PROJECTS_FAILURE'
export const FETCH_WORKSPACE_PROJECTS_SUCCESS = 'sef/FETCH_WORKSPACE_PROJECTS_SUCCESS'
export const GENERATE_PAYFILE = 'sef/GENERATE_PAYFILE'
export const GENERATE_PAYFILE_FAILURE = 'sef/GENERATE_PAYFILE_FAILURE'
export const GENERATE_PAYFILE_SUCCESS = 'sef/GENERATE_PAYFILE_SUCCESS'
export const IMPORT_KWANTU_DATA = 'sef/IMPORT_KWANTU_DATA'
export const IMPORT_KWANTU_DATA_FAILURE = 'sef/IMPORT_KWANTU_DATA_FAILURE'
export const IMPORT_KWANTU_DATA_SUCCESS = 'sef/IMPORT_KWANTU_DATA_SUCCESS'
export const IMPORT_OUTPUTS = 'sef/IMPORT_OUTPUTS'
export const IMPORT_OUTPUTS_FAILURE = 'sef/IMPORT_OUTPUTS_FAILURE'
export const IMPORT_OUTPUTS_SUCCESS = 'sef/IMPORT_OUTPUTS_SUCCESS'
export const IMPORT_PARTICIPANTS = 'sef/IMPORT_PARTICIPANTS'
export const IMPORT_PARTICIPANTS_FAILURE = 'sef/IMPORT_PARTICIPANTS_FAILURE'
export const IMPORT_PARTICIPANTS_SUCCESS = 'sef/IMPORT_PARTICIPANTS_SUCCESS'
export const INITIATE_PAYROLL_REQUEST = 'sef/INITIATE_PAYROLL_REQUEST'
export const INITIATE_PAYROLL_REQUEST_FAILURE = 'sef/INITIATE_PAYROLL_REQUEST_FAILURE'
export const INITIATE_PAYROLL_REQUEST_SUCCESS = 'sef/INITIATE_PAYROLL_REQUEST_SUCCESS'
export const ONBOARD_EMPLOYEE = 'sef/ONBOARD_EMPLOYEE'
export const ONBOARD_EMPLOYEE_FAILURE = 'sef/ONBOARD_EMPLOYEE_FAILURE'
export const ONBOARD_EMPLOYEE_SUCCESS = 'sef/ONBOARD_EMPLOYEE_SUCCESS'
export const PREPARE_KWANTU_DATA = 'sef/PREPARE_KWANTU_DATA'
export const PREPARE_KWANTU_DATA_FAILURE = 'sef/PREPARE_KWANTU_DATA_FAILURE'
export const PREPARE_KWANTU_DATA_SUCCESS = 'sef/PREPARE_KWANTU_DATA_SUCCESS'
export const PROMOTE_PARTICIPANTS = 'sef/PROMOTE_PARTICIPANTS'
export const PROMOTE_PARTICIPANTS_FAILURE = 'sef/PROMOTE_PARTICIPANTS_FAILURE'
export const PROMOTE_PARTICIPANTS_SUCCESS = 'sef/PROMOTE_PARTICIPANTS_SUCCESS'
export const PROVISION_INDICATOR_OUTCOME = 'sef/PROVISION_INDICATOR_OUTCOME'
export const PROVISION_INDICATOR_OUTCOME_FAILURE = 'sef/PROVISION_INDICATOR_OUTCOME_FAILURE'
export const PROVISION_INDICATOR_OUTCOME_SUCCESS = 'sef/PROVISION_INDICATOR_OUTCOME_SUCCESS'
export const REQUEST_AGREEMENT_ZIP = 'sef/REQUEST_AGREEMENT_ZIP'
export const REQUEST_AGREEMENT_ZIP_SUCCESS = 'sef/REQUEST_AGREEMENT_ZIP_SUCCESS'
export const REQUEST_AGREEMENT_ZIP_FAILURE = 'sef/REQUEST_AGREEMENT_ZIP_FAILURE'
export const SEND_OUTCOMES_TRACKING_REMINDER = 'sef/SEND_OUTCOMES_TRACKING_REMINDER'
export const SEND_OUTCOMES_TRACKING_REMINDER_FAILURE = 'sef/SEND_OUTCOMES_TRACKING_REMINDER_FAILURE'
export const SEND_OUTCOMES_TRACKING_REMINDER_SUCCESS = 'sef/SEND_OUTCOMES_TRACKING_REMINDER_SUCCESS'
export const SUBMIT_INDICATOR_OUTCOME = 'sef/SUBMIT_INDICATOR_OUTCOME'
export const SUBMIT_INDICATOR_OUTCOME_FAILURE = 'sef/SUBMIT_INDICATOR_OUTCOME_FAILURE'
export const SUBMIT_INDICATOR_OUTCOME_SUCCESS = 'sef/SUBMIT_INDICATOR_OUTCOME_SUCCESS'
export const UPDATE_AGREEMENT_TEMPLATE = 'sef/UPDATE_AGREEMENT_TEMPLATE'
export const UPDATE_AGREEMENT_TEMPLATE_FAILURE = 'sef/UPDATE_AGREEMENT_TEMPLATE_FAILURE'
export const UPDATE_AGREEMENT_TEMPLATE_SUCCESS = 'sef/UPDATE_AGREEMENT_TEMPLATE_SUCCESS'
export const UPDATE_BUDGET = 'sef/UPDATE_BUDGET'
export const UPDATE_BUDGET_FAILURE = 'sef/UPDATE_BUDGET_FAILURE'
export const UPDATE_BUDGET_SUCCESS = 'sef/UPDATE_BUDGET_SUCCESS'
export const UPDATE_BUDGET_CATEGORY = 'sef/UPDATE_BUDGET_CATEGORY'
export const UPDATE_BUDGET_CATEGORY_FAILURE = 'sef/UPDATE_BUDGET_CATEGORY_FAILURE'
export const UPDATE_BUDGET_CATEGORY_SUCCESS = 'sef/UPDATE_BUDGET_CATEGORY_SUCCESS'
export const UPDATE_MUNICIPALITY = 'sef/UPDATE_MUNICIPALITY'
export const UPDATE_MUNICIPALITY_FAILURE = 'sef/UPDATE_MUNICIPALITY_FAILURE'
export const UPDATE_MUNICIPALITY_SUCCESS = 'sef/UPDATE_MUNICIPALITY_SUCCESS'
export const UPDATE_OUTPUT = 'sef/UPDATE_OUTPUT'
export const UPDATE_OUTPUT_FAILURE = 'sef/UPDATE_OUTPUT_FAILURE'
export const UPDATE_OUTPUT_SUCCESS = 'sef/UPDATE_OUTPUT_SUCCESS'
export const UPDATE_OUTPUT_AREA = 'sef/UPDATE_OUTPUT_AREA'
export const UPDATE_OUTPUT_AREA_FAILURE = 'sef/UPDATE_OUTPUT_AREA_FAILURE'
export const UPDATE_OUTPUT_AREA_SUCCESS = 'sef/UPDATE_OUTPUT_AREA_SUCCESS'
export const UPDATE_OUTPUT_INDICATOR = 'sef/UPDATE_OUTPUT_INDICATOR'
export const UPDATE_OUTPUT_INDICATOR_FAILURE = 'sef/UPDATE_OUTPUT_INDICATOR_FAILURE'
export const UPDATE_OUTPUT_INDICATOR_SUCCESS = 'sef/UPDATE_OUTPUT_INDICATOR_SUCCESS'
export const UPDATE_PARTNER = 'sef/UPDATE_PARTNER'
export const UPDATE_PARTNER_FAILURE = 'sef/UPDATE_PARTNER_FAILURE'
export const UPDATE_PARTNER_SUCCESS = 'sef/UPDATE_PARTNER_SUCCESS'
export const UPDATE_PARTNER_DISTRICT = 'sef/UPDATE_PARTNER_DISTRICT'
export const UPDATE_PARTNER_DISTRICT_FAILURE = 'sef/UPDATE_PARTNER_DISTRICT_FAILURE'
export const UPDATE_PARTNER_DISTRICT_SUCCESS = 'sef/UPDATE_PARTNER_DISTRICT_SUCCESS'
export const UPDATE_PAYROLL_REQUEST = 'sef/UPDATE_PAYROLL_REQUEST'
export const UPDATE_PAYROLL_REQUEST_FAILURE = 'sef/UPDATE_PAYROLL_REQUEST_FAILURE'
export const UPDATE_PAYROLL_REQUEST_SUCCESS = 'sef/UPDATE_PAYROLL_REQUEST_SUCCESS'
export const UPDATE_PLACE = 'sef/UPDATE_PLACE'
export const UPDATE_PLACE_FAILURE = 'sef/UPDATE_PLACE_FAILURE'
export const UPDATE_PLACE_SUCCESS = 'sef/UPDATE_PLACE_SUCCESS'
export const UPDATE_SUPPLIER = 'sef/UPDATE_SUPPLIER'
export const UPDATE_SUPPLIER_FAILURE = 'sef/UPDATE_SUPPLIER_FAILURE'
export const UPDATE_SUPPLIER_SUCCESS = 'sef/UPDATE_SUPPLIER_SUCCESS'
export const UPDATE_WARD = 'sef/UPDATE_WARD'
export const UPDATE_WARD_FAILURE = 'sef/UPDATE_WARD_FAILURE'
export const UPDATE_WARD_SUCCESS = 'sef/UPDATE_WARD_SUCCESS'
export const UPDATE_WORKSITE = 'sef/UPDATE_WORKSITE'
export const UPDATE_WORKSITE_FAILURE = 'sef/UPDATE_WORKSITE_FAILURE'
export const UPDATE_WORKSITE_SUCCESS = 'sef/UPDATE_WORKSITE_SUCCESS'
export const UPDATE_WORKSPACE = 'sef/UPDATE_WORKSPACE'
export const UPDATE_WORKSPACE_FAILURE = 'sef/UPDATE_WORKSPACE_FAILURE'
export const UPDATE_WORKSPACE_SUCCESS = 'sef/UPDATE_WORKSPACE_SUCCESS'
export const UPDATE_WORKSPACE_PROJECT = 'sef/UPDATE_WORKSPACE_PROJECT'
export const UPDATE_WORKSPACE_PROJECT_FAILURE = 'sef/UPDATE_WORKSPACE_PROJECT_FAILURE'
export const UPDATE_WORKSPACE_PROJECT_SUCCESS = 'sef/UPDATE_WORKSPACE_PROJECT_SUCCESS'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const {
  sef: {
    createAgreementTemplate,
    createAgreementTemplateSuccess,
    createAgreementTemplateFailure,
    createBudget,
    createBudgetSuccess,
    createBudgetFailure,
    createBudgetCategory,
    createBudgetCategorySuccess,
    createBudgetCategoryFailure,
    createOutputArea,
    createOutputAreaSuccess,
    createOutputAreaFailure,
    createOutputIndicator,
    createOutputIndicatorSuccess,
    createOutputIndicatorFailure,
    createPartner,
    createPartnerSuccess,
    createPartnerFailure,
    createPayfile,
    createPayfileSuccess,
    createPayfileFailure,
    createPartnerDistrict,
    createPartnerDistrictSuccess,
    createPartnerDistrictFailure,
    createSupplier,
    createSupplierSuccess,
    createSupplierFailure,
    createWorksite,
    createWorksiteSuccess,
    createWorksiteFailure,
    createWorkspace,
    createWorkspaceSuccess,
    createWorkspaceFailure,
    createWorkspaceProject,
    createWorkspaceProjectSuccess,
    createWorkspaceProjectFailure,
    promoteParticipants,
    promoteParticipantsSuccess,
    promoteParticipantsFailure,
    deleteBudgetCategory,
    deleteBudgetCategorySuccess,
    deleteBudgetCategoryFailure,
    deleteOutput,
    deleteOutputSuccess,
    deleteOutputFailure,
    deleteOutputArea,
    deleteOutputAreaSuccess,
    deleteOutputAreaFailure,
    deleteOutputIndicator,
    deleteOutputIndicatorSuccess,
    deleteOutputIndicatorFailure,
    deletePartnerDistrict,
    deletePartnerDistrictSuccess,
    deletePartnerDistrictFailure,
    deleteSupplier,
    deleteSupplierSuccess,
    deleteSupplierFailure,
    deleteWorksite,
    deleteWorksiteSuccess,
    deleteWorksiteFailure,
    deleteWorkspace,
    deleteWorkspaceSuccess,
    deleteWorkspaceFailure,
    deleteWorkspaceProject,
    deleteWorkspaceProjectSuccess,
    deleteWorkspaceProjectFailure,
    fetchActivityReports,
    fetchActivityReportsSuccess,
    fetchActivityReportsFailure,
    fetchAdmins,
    fetchAdminsSuccess,
    fetchAdminsFailure,
    fetchAgreementTemplate,
    fetchAgreementTemplateSuccess,
    fetchAgreementTemplateFailure,
    fetchAgreementTemplates,
    fetchAgreementTemplatesSuccess,
    fetchAgreementTemplatesFailure,
    fetchBudget,
    fetchBudgetSuccess,
    fetchBudgetFailure,
    fetchBudgets,
    fetchBudgetsSuccess,
    fetchBudgetsFailure,
    fetchBudgetCategory,
    fetchBudgetCategorySuccess,
    fetchBudgetCategoryFailure,
    fetchBudgetCategories,
    fetchBudgetCategoriesSuccess,
    fetchBudgetCategoriesFailure,
    fetchDistricts,
    fetchDistrictsSuccess,
    fetchDistrictsFailure,
    fetchEmployeeDetails,
    fetchEmployeeDetailsSuccess,
    fetchEmployeeDetailsFailure,
    fetchMunicipality,
    fetchMunicipalitySuccess,
    fetchMunicipalityFailure,
    fetchMunicipalities,
    fetchMunicipalitiesSuccess,
    fetchMunicipalitiesFailure,
    fetchOnboardingQuestions,
    fetchOnboardingQuestionsSuccess,
    fetchOnboardingQuestionsFailure,
    fetchOutputArea,
    fetchOutputAreaSuccess,
    fetchOutputAreaFailure,
    fetchOutputAreas,
    fetchOutputAreasSuccess,
    fetchOutputAreasFailure,
    fetchOutput,
    fetchOutputSuccess,
    fetchOutputFailure,
    fetchOutputs,
    fetchOutputsSuccess,
    fetchOutputsFailure,
    fetchOutputIndicator,
    fetchOutputIndicatorSuccess,
    fetchOutputIndicatorFailure,
    fetchOutputIndicators,
    fetchOutputIndicatorsSuccess,
    fetchOutputIndicatorsFailure,
    fetchOwnProfileDetails,
    fetchOwnProfileDetailsSuccess,
    fetchOwnProfileDetailsFailure,
    fetchPartnerDistrict,
    fetchPartnerDistrictSuccess,
    fetchPartnerDistrictFailure,
    fetchPartnerDistricts,
    fetchPartnerDistrictsSuccess,
    fetchPartnerDistrictsFailure,
    fetchPartners,
    fetchPartnersSuccess,
    fetchPartnersFailure,
    fetchPayrollBalance,
    fetchPayrollBalanceSuccess,
    fetchPayrollBalanceFailure,
    fetchPayrollHistory,
    fetchPayrollHistorySuccess,
    fetchPayrollHistoryFailure,
    fetchPayrollPaymentRequest,
    fetchPayrollPaymentRequestSuccess,
    fetchPayrollPaymentRequestFailure,
    fetchPayrollPaymentRequests,
    fetchPayrollPaymentRequestsSuccess,
    fetchPayrollPaymentRequestsFailure,
    fetchPlace,
    fetchPlaceSuccess,
    fetchPlaceFailure,
    fetchPlaces,
    fetchPlacesSuccess,
    fetchPlacesFailure,
    fetchScaffoldData,
    fetchScaffoldDataSuccess,
    fetchScaffoldDataFailure,
    fetchStats,
    fetchStatsSuccess,
    fetchStatsFailure,
    fetchSupplier,
    fetchSupplierSuccess,
    fetchSupplierFailure,
    fetchSuppliers,
    fetchSuppliersSuccess,
    fetchSuppliersFailure,
    fetchTimekeepers,
    fetchTimekeepersSuccess,
    fetchTimekeepersFailure,
    fetchWard,
    fetchWardSuccess,
    fetchWardFailure,
    fetchWards,
    fetchWardsSuccess,
    fetchWardsFailure,
    fetchWorksite,
    fetchWorksiteSuccess,
    fetchWorksiteFailure,
    fetchWorksites,
    fetchWorksitesSuccess,
    fetchWorksitesFailure,
    fetchWorkspace,
    fetchWorkspaceSuccess,
    fetchWorkspaceFailure,
    fetchWorkspaces,
    fetchWorkspacesSuccess,
    fetchWorkspacesFailure,
    fetchWorkspaceProject,
    fetchWorkspaceProjectSuccess,
    fetchWorkspaceProjectFailure,
    fetchWorkspaceProjects,
    fetchWorkspaceProjectsSuccess,
    fetchWorkspaceProjectsFailure,
    fetchPrograms,
    fetchProgramsSuccess,
    fetchProgramsFailure,
    importKwantuData,
    importKwantuDataSuccess,
    importKwantuDataFailure,
    importOutputs,
    importOutputsSuccess,
    importOutputsFailure,
    importParticipants,
    importParticipantsSuccess,
    importParticipantsFailure,
    generatePayfile,
    generatePayfileSuccess,
    generatePayfileFailure,
    initiatePayrollRequest,
    initiatePayrollRequestSuccess,
    initiatePayrollRequestFailure,
    onboardEmployee,
    onboardEmployeeSuccess,
    onboardEmployeeFailure,
    prepareKwantuData,
    prepareKwantuDataSuccess,
    prepareKwantuDataFailure,
    provisionIndicatorOutcome,
    provisionIndicatorOutcomeSuccess,
    provisionIndicatorOutcomeFailure,
    requestAgreementZip,
    requestAgreementZipFailure,
    requestAgreementZipSuccess,
    sendOutcomesTrackingReminder,
    sendOutcomesTrackingReminderSuccess,
    sendOutcomesTrackingReminderFailure,
    submitIndicatorOutcome,
    submitIndicatorOutcomeSuccess,
    submitIndicatorOutcomeFailure,
    updateAgreementTemplate,
    updateAgreementTemplateSuccess,
    updateAgreementTemplateFailure,
    updateBudget,
    updateBudgetSuccess,
    updateBudgetFailure,
    updateBudgetCategory,
    updateBudgetCategorySuccess,
    updateBudgetCategoryFailure,
    updateMunicipality,
    updateMunicipalitySuccess,
    updateMunicipalityFailure,
    updateOutput,
    updateOutputSuccess,
    updateOutputFailure,
    updateOutputArea,
    updateOutputAreaSuccess,
    updateOutputAreaFailure,
    updateOutputIndicator,
    updateOutputIndicatorSuccess,
    updateOutputIndicatorFailure,
    updatePartner,
    updatePartnerSuccess,
    updatePartnerFailure,
    updatePartnerDistrict,
    updatePartnerDistrictSuccess,
    updatePartnerDistrictFailure,
    updatePayrollRequest,
    updatePayrollRequestSuccess,
    updatePayrollRequestFailure,
    updatePlace,
    updatePlaceSuccess,
    updatePlaceFailure,
    updateSupplier,
    updateSupplierSuccess,
    updateSupplierFailure,
    updateWard,
    updateWardSuccess,
    updateWardFailure,
    updateWorksite,
    updateWorksiteSuccess,
    updateWorksiteFailure,
    updateWorkspace,
    updateWorkspaceSuccess,
    updateWorkspaceFailure,
    updateWorkspaceProject,
    updateWorkspaceProjectSuccess,
    updateWorkspaceProjectFailure,
    downloadBulkAgreements,
    downloadBulkAgreementsSuccess,
    downloadBulkAgreementsFailure,
    bulkRegenerateAgreements,
    bulkRegenerateAgreementsSuccess,
    bulkRegenerateAgreementsFailure,
    fetchParticipantProfile,
    fetchParticipantProfileSuccess,
    fetchParticipantProfileFailure,
    bulkRegenerateArchives,
    bulkRegenerateArchivesSuccess,
    bulkRegenerateArchivesFailure,
    bulkUploadDocuments,
    bulkUploadDocumentsSuccess,
    bulkUploadDocumentsFailure,
    fetchBulkDocumentUploadStatus,
    fetchBulkDocumentUploadStatusSuccess,
    fetchBulkDocumentUploadStatusFailure,
    resetBulkDocumentUpload,
    bulkRegeneratePayslips,
    bulkRegeneratePayslipsSuccess,
    bulkRegeneratePayslipsFailure
  }
} = createActions({
  [CREATE_AGREEMENT_TEMPLATE]: undefined,
  [CREATE_AGREEMENT_TEMPLATE_FAILURE]: undefined,
  [CREATE_AGREEMENT_TEMPLATE_SUCCESS]: undefined,
  [CREATE_BUDGET]: undefined,
  [CREATE_BUDGET_FAILURE]: undefined,
  [CREATE_BUDGET_SUCCESS]: undefined,
  [CREATE_BUDGET_CATEGORY]: undefined,
  [CREATE_BUDGET_CATEGORY_FAILURE]: undefined,
  [CREATE_BUDGET_CATEGORY_SUCCESS]: undefined,
  [CREATE_OUTPUT_AREA]: undefined,
  [CREATE_OUTPUT_AREA_FAILURE]: undefined,
  [CREATE_OUTPUT_AREA_SUCCESS]: undefined,
  [CREATE_OUTPUT_INDICATOR]: undefined,
  [CREATE_OUTPUT_INDICATOR_FAILURE]: undefined,
  [CREATE_OUTPUT_INDICATOR_SUCCESS]: undefined,
  [CREATE_PARTNER]: undefined,
  [CREATE_PARTNER_FAILURE]: undefined,
  [CREATE_PARTNER_SUCCESS]: undefined,
  [CREATE_PARTNER_DISTRICT]: undefined,
  [CREATE_PARTNER_DISTRICT_FAILURE]: undefined,
  [CREATE_PARTNER_DISTRICT_SUCCESS]: undefined,
  [CREATE_PAYFILE]: undefined,
  [CREATE_PAYFILE_FAILURE]: undefined,
  [CREATE_PAYFILE_SUCCESS]: undefined,
  [CREATE_SUPPLIER]: undefined,
  [CREATE_SUPPLIER_FAILURE]: undefined,
  [CREATE_SUPPLIER_SUCCESS]: undefined,
  [CREATE_WORKSITE]: undefined,
  [CREATE_WORKSITE_FAILURE]: undefined,
  [CREATE_WORKSITE_SUCCESS]: undefined,
  [CREATE_WORKSPACE]: undefined,
  [CREATE_WORKSPACE_FAILURE]: undefined,
  [CREATE_WORKSPACE_SUCCESS]: undefined,
  [CREATE_WORKSPACE_PROJECT]: undefined,
  [CREATE_WORKSPACE_PROJECT_FAILURE]: undefined,
  [CREATE_WORKSPACE_PROJECT_SUCCESS]: undefined,
  [DELETE_BUDGET_CATEGORY]: undefined,
  [DELETE_BUDGET_CATEGORY_FAILURE]: undefined,
  [DELETE_BUDGET_CATEGORY_SUCCESS]: undefined,
  [DELETE_OUTPUT]: undefined,
  [DELETE_OUTPUT_FAILURE]: undefined,
  [DELETE_OUTPUT_SUCCESS]: undefined,
  [DELETE_OUTPUT_AREA]: undefined,
  [DELETE_OUTPUT_AREA_FAILURE]: undefined,
  [DELETE_OUTPUT_AREA_SUCCESS]: undefined,
  [DELETE_OUTPUT_INDICATOR]: undefined,
  [DELETE_OUTPUT_INDICATOR_FAILURE]: undefined,
  [DELETE_OUTPUT_INDICATOR_SUCCESS]: undefined,
  [DELETE_PARTNER_DISTRICT]: undefined,
  [DELETE_PARTNER_DISTRICT_FAILURE]: undefined,
  [DELETE_PARTNER_DISTRICT_SUCCESS]: undefined,
  [DELETE_SUPPLIER]: undefined,
  [DELETE_SUPPLIER_FAILURE]: undefined,
  [DELETE_SUPPLIER_SUCCESS]: undefined,
  [DELETE_WORKSITE]: undefined,
  [DELETE_WORKSITE_FAILURE]: undefined,
  [DELETE_WORKSITE_SUCCESS]: undefined,
  [DELETE_WORKSPACE]: undefined,
  [DELETE_WORKSPACE_FAILURE]: undefined,
  [DELETE_WORKSPACE_SUCCESS]: undefined,
  [DELETE_WORKSPACE_PROJECT]: undefined,
  [DELETE_WORKSPACE_PROJECT_FAILURE]: undefined,
  [DELETE_WORKSPACE_PROJECT_SUCCESS]: undefined,
  [DOWNLOAD_BULK_AGREEMENTS]: undefined,
  [DOWNLOAD_BULK_AGREEMENTS_FAILURE]: undefined,
  [DOWNLOAD_BULK_AGREEMENTS_SUCCESS]: undefined,
  [BULK_REGENERATE_AGREEMENTS]: undefined,
  [BULK_REGENERATE_AGREEMENTS_FAILURE]: undefined,
  [BULK_REGENERATE_AGREEMENTS_SUCCESS]: undefined,
  [BULK_REGENERATE_ARCHIVES]: undefined,
  [BULK_REGENERATE_ARCHIVES_FAILURE]: undefined,
  [BULK_REGENERATE_ARCHIVES_SUCCESS]: undefined,
  [BULK_UPLOAD_DOCUMENTS]: undefined,
  [BULK_UPLOAD_DOCUMENTS_FAILURE]: undefined,
  [BULK_UPLOAD_DOCUMENTS_SUCCESS]: undefined,
  [FETCH_BULK_DOCUMENT_UPLOAD_STATUS]: undefined,
  [FETCH_BULK_DOCUMENT_UPLOAD_STATUS_FAILURE]: undefined,
  [FETCH_BULK_DOCUMENT_UPLOAD_STATUS_SUCCESS]: undefined,
  [RESET_BULK_DOCUMENT_UPLOAD]: undefined,
  [BULK_REGENERATE_PAYSLIPS]: undefined,
  [BULK_REGENERATE_PAYSLIPS_FAILURE]: undefined,
  [BULK_REGENERATE_PAYSLIPS_SUCCESS]: undefined,
  [FETCH_ACTIVITY_REPORTS]: undefined,
  [FETCH_ACTIVITY_REPORTS_FAILURE]: undefined,
  [FETCH_ACTIVITY_REPORTS_SUCCESS]: undefined,
  [FETCH_ADMINS]: undefined,
  [FETCH_ADMINS_FAILURE]: undefined,
  [FETCH_ADMINS_SUCCESS]: undefined,
  [FETCH_AGREEMENT_TEMPLATE]: undefined,
  [FETCH_AGREEMENT_TEMPLATE_FAILURE]: undefined,
  [FETCH_AGREEMENT_TEMPLATE_SUCCESS]: undefined,
  [FETCH_AGREEMENT_TEMPLATES]: undefined,
  [FETCH_AGREEMENT_TEMPLATES_FAILURE]: undefined,
  [FETCH_AGREEMENT_TEMPLATES_SUCCESS]: undefined,
  [FETCH_BUDGET]: undefined,
  [FETCH_BUDGET_FAILURE]: undefined,
  [FETCH_BUDGET_SUCCESS]: undefined,
  [FETCH_BUDGETS]: undefined,
  [FETCH_BUDGETS_FAILURE]: undefined,
  [FETCH_BUDGETS_SUCCESS]: undefined,
  [FETCH_BUDGET_CATEGORY]: undefined,
  [FETCH_BUDGET_CATEGORY_FAILURE]: undefined,
  [FETCH_BUDGET_CATEGORY_SUCCESS]: undefined,
  [FETCH_BUDGET_CATEGORIES]: undefined,
  [FETCH_BUDGET_CATEGORIES_FAILURE]: undefined,
  [FETCH_BUDGET_CATEGORIES_SUCCESS]: undefined,
  [FETCH_DISTRICTS]: undefined,
  [FETCH_DISTRICTS_FAILURE]: undefined,
  [FETCH_DISTRICTS_SUCCESS]: undefined,
  [FETCH_EMPLOYEE_DETAILS]: undefined,
  [FETCH_EMPLOYEE_DETAILS_FAILURE]: undefined,
  [FETCH_EMPLOYEE_DETAILS_SUCCESS]: undefined,
  [FETCH_MUNICIPALITY]: undefined,
  [FETCH_MUNICIPALITY_FAILURE]: undefined,
  [FETCH_MUNICIPALITY_SUCCESS]: undefined,
  [FETCH_MUNICIPALITIES]: undefined,
  [FETCH_MUNICIPALITIES_FAILURE]: undefined,
  [FETCH_MUNICIPALITIES_SUCCESS]: undefined,
  [FETCH_ONBOARDING_QUESTIONS]: undefined,
  [FETCH_ONBOARDING_QUESTIONS_SUCCESS]: undefined,
  [FETCH_ONBOARDING_QUESTIONS_FAILURE]: undefined,
  [FETCH_OUTPUT]: undefined,
  [FETCH_OUTPUT_FAILURE]: undefined,
  [FETCH_OUTPUT_SUCCESS]: undefined,
  [FETCH_OUTPUTS]: undefined,
  [FETCH_OUTPUTS_FAILURE]: undefined,
  [FETCH_OUTPUTS_SUCCESS]: undefined,
  [FETCH_OUTPUT_AREA]: undefined,
  [FETCH_OUTPUT_AREA_FAILURE]: undefined,
  [FETCH_OUTPUT_AREA_SUCCESS]: undefined,
  [FETCH_OUTPUT_AREAS]: undefined,
  [FETCH_OUTPUT_AREAS_FAILURE]: undefined,
  [FETCH_OUTPUT_AREAS_SUCCESS]: undefined,
  [FETCH_OUTPUT_INDICATOR]: undefined,
  [FETCH_OUTPUT_INDICATOR_FAILURE]: undefined,
  [FETCH_OUTPUT_INDICATOR_SUCCESS]: undefined,
  [FETCH_OUTPUT_INDICATORS]: undefined,
  [FETCH_OUTPUT_INDICATORS_FAILURE]: undefined,
  [FETCH_OUTPUT_INDICATORS_SUCCESS]: undefined,
  [FETCH_OWN_PROFILE_DETAILS]: undefined,
  [FETCH_OWN_PROFILE_DETAILS_SUCCESS]: undefined,
  [FETCH_OWN_PROFILE_DETAILS_FAILURE]: undefined,
  [FETCH_PARTNER_DISTRICT]: undefined,
  [FETCH_PARTNER_DISTRICT_FAILURE]: undefined,
  [FETCH_PARTNER_DISTRICT_SUCCESS]: undefined,
  [FETCH_PARTNER_DISTRICTS]: undefined,
  [FETCH_PARTNER_DISTRICTS_FAILURE]: undefined,
  [FETCH_PARTNER_DISTRICTS_SUCCESS]: undefined,
  [FETCH_PARTNERS]: undefined,
  [FETCH_PARTNERS_FAILURE]: undefined,
  [FETCH_PARTNERS_SUCCESS]: undefined,
  [FETCH_PAYROLL_BALANCE]: undefined,
  [FETCH_PAYROLL_BALANCE_FAILURE]: undefined,
  [FETCH_PAYROLL_BALANCE_SUCCESS]: undefined,
  [FETCH_PAYROLL_HISTORY]: undefined,
  [FETCH_PAYROLL_HISTORY_FAILURE]: undefined,
  [FETCH_PAYROLL_HISTORY_SUCCESS]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUEST]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUEST_FAILURE]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUEST_SUCCESS]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUESTS]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUESTS_FAILURE]: undefined,
  [FETCH_PAYROLL_PAYMENT_REQUESTS_SUCCESS]: undefined,
  [FETCH_PLACE]: undefined,
  [FETCH_PLACE_FAILURE]: undefined,
  [FETCH_PLACE_SUCCESS]: undefined,
  [FETCH_PLACES]: undefined,
  [FETCH_PLACES_FAILURE]: undefined,
  [FETCH_PLACES_SUCCESS]: undefined,
  [FETCH_SCAFFOLD_DATA]: undefined,
  [FETCH_SCAFFOLD_DATA_FAILURE]: undefined,
  [FETCH_SCAFFOLD_DATA_SUCCESS]: undefined,
  [FETCH_STATS]: undefined,
  [FETCH_STATS_FAILURE]: undefined,
  [FETCH_STATS_SUCCESS]: undefined,
  [FETCH_SUPPLIER]: undefined,
  [FETCH_SUPPLIER_FAILURE]: undefined,
  [FETCH_SUPPLIER_SUCCESS]: undefined,
  [FETCH_SUPPLIERS]: undefined,
  [FETCH_SUPPLIERS_FAILURE]: undefined,
  [FETCH_SUPPLIERS_SUCCESS]: undefined,
  [FETCH_TIMEKEEPERS]: undefined,
  [FETCH_TIMEKEEPERS_FAILURE]: undefined,
  [FETCH_TIMEKEEPERS_SUCCESS]: undefined,
  [FETCH_WARD]: undefined,
  [FETCH_WARD_FAILURE]: undefined,
  [FETCH_WARD_SUCCESS]: undefined,
  [FETCH_WARDS]: undefined,
  [FETCH_WARDS_FAILURE]: undefined,
  [FETCH_WARDS_SUCCESS]: undefined,
  [FETCH_WORKSITE]: undefined,
  [FETCH_WORKSITE_FAILURE]: undefined,
  [FETCH_WORKSITE_SUCCESS]: undefined,
  [FETCH_WORKSITES]: undefined,
  [FETCH_WORKSITES_FAILURE]: undefined,
  [FETCH_WORKSITES_SUCCESS]: undefined,
  [FETCH_WORKSPACE]: undefined,
  [FETCH_WORKSPACE_FAILURE]: undefined,
  [FETCH_WORKSPACE_SUCCESS]: undefined,
  [FETCH_WORKSPACES]: undefined,
  [FETCH_WORKSPACES_FAILURE]: undefined,
  [FETCH_WORKSPACES_SUCCESS]: undefined,
  [FETCH_WORKSPACE_PROJECT]: undefined,
  [FETCH_WORKSPACE_PROJECT_FAILURE]: undefined,
  [FETCH_WORKSPACE_PROJECT_SUCCESS]: undefined,
  [FETCH_WORKSPACE_PROJECTS]: undefined,
  [FETCH_WORKSPACE_PROJECTS_FAILURE]: undefined,
  [FETCH_WORKSPACE_PROJECTS_SUCCESS]: undefined,
  [FETCH_PROGRAMS]: undefined,
  [FETCH_PROGRAMS_FAILURE]: undefined,
  [FETCH_PROGRAMS_SUCCESS]: undefined,
  [IMPORT_OUTPUTS]: undefined,
  [IMPORT_OUTPUTS_FAILURE]: undefined,
  [IMPORT_OUTPUTS_SUCCESS]: undefined,
  [PREPARE_KWANTU_DATA]: undefined,
  [PREPARE_KWANTU_DATA_FAILURE]: undefined,
  [PREPARE_KWANTU_DATA_SUCCESS]: undefined,
  [IMPORT_KWANTU_DATA]: undefined,
  [IMPORT_KWANTU_DATA_FAILURE]: undefined,
  [IMPORT_KWANTU_DATA_SUCCESS]: undefined,
  [IMPORT_PARTICIPANTS]: undefined,
  [IMPORT_PARTICIPANTS_FAILURE]: undefined,
  [IMPORT_PARTICIPANTS_SUCCESS]: undefined,
  [GENERATE_PAYFILE]: undefined,
  [GENERATE_PAYFILE_FAILURE]: undefined,
  [GENERATE_PAYFILE_SUCCESS]: undefined,
  [INITIATE_PAYROLL_REQUEST]: undefined,
  [INITIATE_PAYROLL_REQUEST_FAILURE]: undefined,
  [INITIATE_PAYROLL_REQUEST_SUCCESS]: undefined,
  [ONBOARD_EMPLOYEE]: undefined,
  [ONBOARD_EMPLOYEE_FAILURE]: undefined,
  [ONBOARD_EMPLOYEE_SUCCESS]: undefined,
  [PROMOTE_PARTICIPANTS]: undefined,
  [PROMOTE_PARTICIPANTS_FAILURE]: undefined,
  [PROMOTE_PARTICIPANTS_SUCCESS]: undefined,
  [PROVISION_INDICATOR_OUTCOME]: undefined,
  [PROVISION_INDICATOR_OUTCOME_FAILURE]: undefined,
  [PROVISION_INDICATOR_OUTCOME_SUCCESS]: undefined,
  [REQUEST_AGREEMENT_ZIP]: undefined,
  [REQUEST_AGREEMENT_ZIP_FAILURE]: undefined,
  [REQUEST_AGREEMENT_ZIP_SUCCESS]: undefined,
  [SEND_OUTCOMES_TRACKING_REMINDER]: undefined,
  [SEND_OUTCOMES_TRACKING_REMINDER_FAILURE]: undefined,
  [SEND_OUTCOMES_TRACKING_REMINDER_SUCCESS]: undefined,
  [SUBMIT_INDICATOR_OUTCOME]: undefined,
  [SUBMIT_INDICATOR_OUTCOME_FAILURE]: undefined,
  [SUBMIT_INDICATOR_OUTCOME_SUCCESS]: undefined,
  [UPDATE_AGREEMENT_TEMPLATE]: undefined,
  [UPDATE_AGREEMENT_TEMPLATE_FAILURE]: undefined,
  [UPDATE_AGREEMENT_TEMPLATE_SUCCESS]: undefined,
  [UPDATE_BUDGET]: undefined,
  [UPDATE_BUDGET_FAILURE]: undefined,
  [UPDATE_BUDGET_SUCCESS]: undefined,
  [UPDATE_BUDGET_CATEGORY]: undefined,
  [UPDATE_BUDGET_CATEGORY_FAILURE]: undefined,
  [UPDATE_BUDGET_CATEGORY_SUCCESS]: undefined,
  [UPDATE_MUNICIPALITY]: undefined,
  [UPDATE_MUNICIPALITY_FAILURE]: undefined,
  [UPDATE_MUNICIPALITY_SUCCESS]: undefined,
  [UPDATE_OUTPUT]: undefined,
  [UPDATE_OUTPUT_FAILURE]: undefined,
  [UPDATE_OUTPUT_SUCCESS]: undefined,
  [UPDATE_OUTPUT_AREA]: undefined,
  [UPDATE_OUTPUT_AREA_FAILURE]: undefined,
  [UPDATE_OUTPUT_AREA_SUCCESS]: undefined,
  [UPDATE_OUTPUT_INDICATOR]: undefined,
  [UPDATE_OUTPUT_INDICATOR_FAILURE]: undefined,
  [UPDATE_OUTPUT_INDICATOR_SUCCESS]: undefined,
  [UPDATE_PARTNER]: undefined,
  [UPDATE_PARTNER_FAILURE]: undefined,
  [UPDATE_PARTNER_SUCCESS]: undefined,
  [UPDATE_PARTNER_DISTRICT]: undefined,
  [UPDATE_PARTNER_DISTRICT_FAILURE]: undefined,
  [UPDATE_PARTNER_DISTRICT_SUCCESS]: undefined,
  [UPDATE_PAYROLL_REQUEST]: undefined,
  [UPDATE_PAYROLL_REQUEST_FAILURE]: undefined,
  [UPDATE_PAYROLL_REQUEST_SUCCESS]: undefined,
  [UPDATE_PLACE]: undefined,
  [UPDATE_PLACE_FAILURE]: undefined,
  [UPDATE_PLACE_SUCCESS]: undefined,
  [UPDATE_SUPPLIER]: undefined,
  [UPDATE_SUPPLIER_FAILURE]: undefined,
  [UPDATE_SUPPLIER_SUCCESS]: undefined,
  [UPDATE_WARD]: undefined,
  [UPDATE_WARD_FAILURE]: undefined,
  [UPDATE_WARD_SUCCESS]: undefined,
  [UPDATE_WORKSITE]: undefined,
  [UPDATE_WORKSITE_FAILURE]: undefined,
  [UPDATE_WORKSITE_SUCCESS]: undefined,
  [UPDATE_WORKSPACE]: undefined,
  [UPDATE_WORKSPACE_FAILURE]: undefined,
  [UPDATE_WORKSPACE_SUCCESS]: undefined,
  [UPDATE_WORKSPACE_PROJECT]: undefined,
  [UPDATE_WORKSPACE_PROJECT_FAILURE]: undefined,
  [UPDATE_WORKSPACE_PROJECT_SUCCESS]: undefined,
  [FETCH_PARTICIPANT_PROFILE]: undefined,
  [FETCH_PARTICIPANT_PROFILE_FAILURE]: undefined,
  [FETCH_PARTICIPANT_PROFILE_SUCCESS]: undefined
})

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  onboardingQuestionsData: [],
  ownProfileDetails: {},
  employeeDetails: {},
  kwantuAttendanceData: {},
  kwantuPaymentsData: {},
  paginatedAdminsData: {
    adminUsers: [],
    adminUsersCount: 0,
    adminUsersPageCount: 0
  },
  paginatedAgreementTemplatesData: {
    agreementTemplates: [],
    agreementTemplatesCount: 0,
    agreementTemplatesPageCount: 0
  },
  paginatedBudgetCategoriesData: {
    budgetCategories: [],
    budgetCategoriesCount: 0,
    budgetCategoriesPageCount: 0
  },
  paginatedBudgetsData: {
    budgets: [],
    budgetsCount: 0,
    budgetsPageCount: 0
  },
  paginatedDistrictsData: { districts: [], districtsCount: 0, districtsPageCount: 0 },
  paginatedMunicipalitiesData: {
    municipalities: [],
    municipalitiesCount: 0,
    municipalitiesPageCount: 0
  },
  paginatedOutputsData: {
    outputs: [],
    outputsCount: 0,
    outputsPageCount: 0
  },
  paginatedOutputAreasData: {
    outputAreas: [],
    outputAreasCount: 0,
    outputAreasPageCount: 0
  },
  paginatedIndicatorsData: {
    indicators: [],
    indicatorsCount: 0,
    indicatorsPageCount: 0
  },
  paginatedPartnerDistrictsData: {
    partnerDistricts: [],
    partnerDistrictsCount: 0,
    partnerDistrictsPageCount: 0
  },
  paginatedPartnersData: { partners: [], partnersCount: 0, partnersPageCount: 0 },
  paginatedPayrollPaymentRequestsData: {
    payrollPaymentRequests: [],
    payrollPaymentRequestsCount: 0,
    payrollPaymentRequestsPageCount: 0
  },
  paginatedPayrollData: { payroll: [], payrollCount: 0, payrollPageCount: 0 },
  paginatedPlacesData: { places: [], placesCount: 0, placesPageCount: 0 },
  paginatedSuppliersData: { suppliers: [], suppliersCount: 0, suppliersPageCount: 0 },
  paginatedWardsData: { wards: [], wardsCount: 0, wardsPageCount: 0 },
  paginatedWorksitesData: { worksites: [], worksitesCount: 0, worksitesPageCount: 0 },
  paginatedWorkspacesData: { workspaces: [], workspacesCount: 0, workspacesPageCount: 0 },
  paginatedWorkspaceProjectsData: {
    workspaceProjects: [],
    workspaceProjectsCount: 0,
    workspaceProjectsPageCount: 0
  },
  paginatedProgramsData: {
    programs: [],
    programsCount: 0,
    programsPageCount: 0
  },
  provincesData: [],
  timekeepersData: [],
  singleAgreementTemplateData: {},
  singleBudgetData: {},
  singleBudgetCategoryData: {},
  singleMunicipalityData: {},
  requestedZipFile: null,
  payrollObject: null,
  purchaseRequestObject: null,
  bulkDocumentUpload: null,
  bulkDocumentUploadStatus: null,
  scaffoldData: {},
  singleOutputAreaData: {},
  singleOutputData: {},
  singleIndicatorData: {},
  singlePartnerData: {},
  singlePartnerDistrictData: {},
  singlePartnerDistrictError: null,
  singlePlaceData: {},
  singleSupplierData: {},
  singleWardData: {},
  singleWorksiteData: {},
  singleWorkspaceData: {},
  singleWorkspaceProjectData: {},
  dataPortals: [],
  statsData: {}
}

export default handleActions(
  {
    [CREATE_AGREEMENT_TEMPLATE]: startSubmitting,
    [CREATE_AGREEMENT_TEMPLATE_FAILURE]: loadingError,
    [CREATE_AGREEMENT_TEMPLATE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_BUDGET]: startSubmitting,
    [CREATE_BUDGET_FAILURE]: loadingError,
    [CREATE_BUDGET_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_BUDGET_CATEGORY]: startSubmitting,
    [CREATE_BUDGET_CATEGORY_FAILURE]: loadingError,
    [CREATE_BUDGET_CATEGORY_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_OUTPUT_AREA]: startSubmitting,
    [CREATE_OUTPUT_AREA_FAILURE]: loadingError,
    [CREATE_OUTPUT_AREA_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_OUTPUT_INDICATOR]: startSubmitting,
    [CREATE_OUTPUT_INDICATOR_FAILURE]: loadingError,
    [CREATE_OUTPUT_INDICATOR_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_PARTNER]: startSubmitting,
    [CREATE_PARTNER_FAILURE]: loadingError,
    [CREATE_PARTNER_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_PARTNER_DISTRICT]: startSubmitting,
    [CREATE_PARTNER_DISTRICT_FAILURE]: loadingError,
    [CREATE_PARTNER_DISTRICT_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_PAYFILE]: startSubmitting,
    [CREATE_PAYFILE_FAILURE]: loadingError,
    [CREATE_PAYFILE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_SUPPLIER]: startSubmitting,
    [CREATE_SUPPLIER_FAILURE]: loadingError,
    [CREATE_SUPPLIER_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_WORKSITE]: startSubmitting,
    [CREATE_WORKSITE_FAILURE]: loadingError,
    [CREATE_WORKSITE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_WORKSPACE]: startSubmitting,
    [CREATE_WORKSPACE_FAILURE]: loadingError,
    [CREATE_WORKSPACE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [CREATE_WORKSPACE_PROJECT]: startSubmitting,
    [CREATE_WORKSPACE_PROJECT_FAILURE]: loadingError,
    [CREATE_WORKSPACE_PROJECT_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_BUDGET_CATEGORY]: state => ({ ...state, isLoading: true }),
    [DELETE_BUDGET_CATEGORY_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_BUDGET_CATEGORY_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_OUTPUT]: state => ({ ...state, isLoading: true }),
    [DELETE_OUTPUT_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_OUTPUT_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_OUTPUT_AREA]: state => ({ ...state, isLoading: true }),
    [DELETE_OUTPUT_AREA_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_OUTPUT_AREA_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_OUTPUT_INDICATOR]: state => ({ ...state, isLoading: true }),
    [DELETE_OUTPUT_INDICATOR_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_OUTPUT_INDICATOR_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_PARTNER_DISTRICT]: state => ({
      ...state,
      isLoading: true
    }),
    [DELETE_PARTNER_DISTRICT_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false
      }
    },
    [DELETE_PARTNER_DISTRICT_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_SUPPLIER]: state => ({ ...state, isLoading: true }),
    [DELETE_SUPPLIER_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_SUPPLIER_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_WORKSITE]: state => ({ ...state, isLoading: true }),
    [DELETE_WORKSITE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_WORKSITE_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_WORKSPACE]: state => ({ ...state, isLoading: true }),
    [DELETE_WORKSPACE_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_WORKSPACE_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_WORKSPACE_PROJECT]: state => ({ ...state, isLoading: true }),
    [DELETE_WORKSPACE_PROJECT_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_WORKSPACE_PROJECT_FAILURE]: state => ({ ...state, isLoading: false }),
    [FETCH_ACTIVITY_REPORTS]: startLoading,
    [FETCH_ACTIVITY_REPORTS_FAILURE]: loadingError,
    [FETCH_ACTIVITY_REPORTS_SUCCESS]: (state, { payload }) => ({
      ...state,
      activityReports: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_ADMINS]: startLoading,
    [FETCH_ADMINS_FAILURE]: loadingError,
    [FETCH_ADMINS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true
      }

      // TEMPORARY FIX
      newState.paginatedAdminsData.adminUsersPageCount = payload.pageCount || 0
      newState.paginatedAdminsData.adminsCount = payload.adminsCount || 0
      newState.paginatedAdminsData.adminUsers = payload.adminUsers || []

      return newState
    },
    [FETCH_AGREEMENT_TEMPLATE]: startLoading,
    [FETCH_AGREEMENT_TEMPLATE_FAILURE]: loadingError,
    [FETCH_AGREEMENT_TEMPLATE_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleAgreementTemplateData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_AGREEMENT_TEMPLATES]: startLoading,
    [FETCH_AGREEMENT_TEMPLATES_FAILURE]: loadingError,
    [FETCH_AGREEMENT_TEMPLATES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true
      }

      newState.paginatedAgreementTemplatesData.agreementTemplatesPageCount = payload.pageCount || 0
      newState.paginatedAgreementTemplatesData.agreementTemplatesCount =
        payload.agreementTemplatesCount || 0
      newState.paginatedAgreementTemplatesData.agreementTemplates = payload.agreementTemplates || []

      return newState
    },
    [FETCH_BUDGET]: startLoading,
    [FETCH_BUDGET_FAILURE]: loadingError,
    [FETCH_BUDGET_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleBudgetData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_BUDGET_CATEGORY]: startLoading,
    [FETCH_BUDGET_CATEGORY_FAILURE]: loadingError,
    [FETCH_BUDGET_CATEGORY_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleBudgetCategoryData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_BUDGETS]: startLoading,
    [FETCH_BUDGETS_FAILURE]: loadingError,
    [FETCH_BUDGETS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true
      }

      newState.paginatedBudgetsData.budgetsPageCount = payload.pageCount || 0
      newState.paginatedBudgetsData.budgetsCount = payload.budgetsCount || 0
      newState.paginatedBudgetsData.budgets = payload.budgets || []

      return newState
    },
    [FETCH_BUDGET_CATEGORIES]: startLoading,
    [FETCH_BUDGET_CATEGORIES_FAILURE]: loadingError,
    [FETCH_BUDGET_CATEGORIES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true
      }

      newState.paginatedBudgetCategoriesData.budgetCategoriesPageCount = payload.pageCount || 0
      newState.paginatedBudgetCategoriesData.budgetCategoriesCount =
        payload.budgetCategoriesCount || 0
      newState.paginatedBudgetCategoriesData.budgetCategories = payload.budgetCategories || []

      return newState
    },
    [FETCH_DISTRICTS]: startLoading,
    [FETCH_DISTRICTS_FAILURE]: loadingError,
    [FETCH_DISTRICTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true,
        provincesData: payload.provinces
      }

      newState.paginatedDistrictsData.districtsPageCount = payload.pageCount || 0
      newState.paginatedDistrictsData.districtsCount = payload.districtsCount || 0
      newState.paginatedDistrictsData.districts = payload.districts || []

      return newState
    },
    [FETCH_EMPLOYEE_DETAILS]: startLoading,
    [FETCH_EMPLOYEE_DETAILS_FAILURE]: loadingError,
    [FETCH_EMPLOYEE_DETAILS_SUCCESS]: (state, { payload }) => ({
      ...state,
      errorMessage: null,
      hasSubmitted: false,
      isError: false,
      isLoading: false,
      isSuccess: true,
      employeeDetails: payload
    }),
    [UPDATE_BUDGET]: startSubmitting,
    [UPDATE_BUDGET_FAILURE]: loadingError,
    [UPDATE_BUDGET_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_BUDGET_CATEGORY]: startSubmitting,
    [UPDATE_BUDGET_CATEGORY_FAILURE]: loadingError,
    [UPDATE_BUDGET_CATEGORY_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_PARTNER]: startSubmitting,
    [UPDATE_PARTNER_FAILURE]: loadingError,
    [UPDATE_PARTNER_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_PARTNER_DISTRICT]: startSubmitting,
    [UPDATE_PARTNER_DISTRICT_FAILURE]: loadingError,
    [UPDATE_PARTNER_DISTRICT_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_PAYROLL_REQUEST]: startSubmitting,
    [UPDATE_PAYROLL_REQUEST_FAILURE]: loadingError,
    [UPDATE_PAYROLL_REQUEST_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [FETCH_OUTPUT]: startLoading,
    [FETCH_OUTPUT_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleOutputData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_OUTPUT_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_OUTPUT_AREA]: startLoading,
    [FETCH_OUTPUT_AREA_FAILURE]: loadingError,
    [FETCH_OUTPUT_AREA_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleOutputAreaData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_OUTPUT_INDICATOR]: startLoading,
    [FETCH_OUTPUT_INDICATOR_FAILURE]: loadingError,
    [FETCH_OUTPUT_INDICATOR_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleIndicatorData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_MUNICIPALITY]: startLoading,
    [FETCH_MUNICIPALITY_FAILURE]: loadingError,
    [FETCH_MUNICIPALITY_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleMunicipalityData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_MUNICIPALITIES]: startLoading,
    [FETCH_MUNICIPALITIES_FAILURE]: loadingError,
    [FETCH_MUNICIPALITIES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedMunicipalitiesData.municipalitiesPageCount = 1
      newState.paginatedMunicipalitiesData.municipalitiesCount = payload.length
      newState.paginatedMunicipalitiesData.municipalities = payload || []

      return newState
    },
    [FETCH_ONBOARDING_QUESTIONS]: startLoading,
    [FETCH_ONBOARDING_QUESTIONS_FAILURE]: loadingError,
    [FETCH_ONBOARDING_QUESTIONS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null,
        onboardingQuestionsData: payload
      }

      return newState
    },
    [FETCH_OWN_PROFILE_DETAILS]: startLoading,
    [FETCH_OWN_PROFILE_DETAILS_FAILURE]: loadingError,
    [FETCH_OWN_PROFILE_DETAILS_SUCCESS]: (state, { payload }) => ({
      ...state,
      ownProfileDetails: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_PARTNER_DISTRICT]: startLoading,
    [FETCH_PARTNER_DISTRICT_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true,
      singlePartnerDistrictError: true
    }),
    [FETCH_PARTNER_DISTRICT_SUCCESS]: (state, { payload }) => ({
      ...state,
      provincesData: payload.provinces,
      singlePartnerDistrictData: payload.district,
      isLoading: false,
      isError: false
    }),
    [FETCH_PARTNER_DISTRICTS]: startLoading,
    [FETCH_PARTNER_DISTRICTS_FAILURE]: loadingError,
    [FETCH_PARTNER_DISTRICTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedPartnerDistrictsData.partnerDistrictsPageCount = payload.pageCount || 0
      newState.paginatedPartnerDistrictsData.partnerDistrictsCount =
        payload.partnerDistrictsCount || 0
      newState.paginatedPartnerDistrictsData.partnerDistricts = payload.partnerDistricts || []

      return newState
    },
    [FETCH_OUTPUT_AREAS]: startLoading,
    [FETCH_OUTPUT_AREAS_FAILURE]: loadingError,
    [FETCH_OUTPUT_AREAS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedOutputAreasData.outputAreasPageCount = payload.pageCount || 0
      newState.paginatedOutputAreasData.outputAreasCount = payload.outputAreasCount || 0
      newState.paginatedOutputAreasData.outputAreas = payload.outputAreas || []
      newState.paginatedOutputAreasData.outputSubAreas = payload.outputSubAreas || []

      return newState
    },
    [FETCH_OUTPUTS]: startLoading,
    [FETCH_OUTPUTS_FAILURE]: loadingError,
    [FETCH_OUTPUTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedOutputsData.outputsPageCount = payload.pageCount || 0
      newState.paginatedOutputsData.outputsCount = payload.outputsCount || 0
      newState.paginatedOutputsData.outputs = payload.outputs || []

      return newState
    },
    [FETCH_OUTPUT_INDICATORS]: startLoading,
    [FETCH_OUTPUT_INDICATORS_FAILURE]: loadingError,
    [FETCH_OUTPUT_INDICATORS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedIndicatorsData.indicatorsPageCount = payload.pageCount || 0
      newState.paginatedIndicatorsData.indicatorsCount = payload.indicatorsCount || 0
      newState.paginatedIndicatorsData.indicators = payload.indicators || []

      return newState
    },
    [FETCH_PARTNERS]: startLoading,
    [FETCH_PARTNERS_FAILURE]: loadingError,
    [FETCH_PARTNERS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedPartnersData.partnersPageCount = payload.pageCount || 0
      newState.paginatedPartnersData.partnersCount = payload.partnersCount || 0
      newState.paginatedPartnersData.partners = payload.partners || []

      return newState
    },
    [FETCH_PAYROLL_HISTORY]: startLoading,
    [FETCH_PAYROLL_HISTORY_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      payrollError: payload.message
    }),
    [FETCH_PAYROLL_HISTORY_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true
      }

      newState.paginatedPayrollData.payrollPageCount = payload.pageCount || 0
      newState.paginatedPayrollData.payrollCount = payload.payrollCount || 0
      newState.paginatedPayrollData.payroll = payload.payroll || []

      return newState
    },
    [FETCH_PAYROLL_BALANCE]: startLoading,
    [FETCH_PAYROLL_BALANCE_FAILURE]: loadingError,
    [FETCH_PAYROLL_BALANCE_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null,
        payrollBalance: payload.accountBalance
      }

      return newState
    },
    [FETCH_PAYROLL_PAYMENT_REQUEST]: startLoading,
    [FETCH_PAYROLL_PAYMENT_REQUEST_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      payrollError: payload.message
    }),
    [FETCH_PAYROLL_PAYMENT_REQUEST_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null,
        singlePaymentRequestData: payload
      }

      return newState
    },
    [FETCH_PAYROLL_PAYMENT_REQUESTS]: startLoading,
    [FETCH_PAYROLL_PAYMENT_REQUESTS_FAILURE]: loadingError,
    [FETCH_PAYROLL_PAYMENT_REQUESTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,
        errorMessage: null
      }

      newState.paginatedPayrollPaymentRequestsData.payrollPaymentRequestsPageCount =
        payload.pageCount || 0
      newState.paginatedPayrollPaymentRequestsData.payrollPaymentRequestsCount =
        payload.payrollPaymentRequestsCount || 0
      newState.paginatedPayrollPaymentRequestsData.payrollPaymentRequests =
        payload.payrollPaymentRequests || []

      return newState
    },
    [FETCH_PLACE]: startLoading,
    [FETCH_PLACE_FAILURE]: loadingError,
    [FETCH_PLACE_SUCCESS]: (state, { payload }) => ({
      ...state,
      singlePlaceData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_PLACES]: startLoading,
    [FETCH_PLACES_FAILURE]: loadingError,
    [FETCH_PLACES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedPlacesData.placesPageCount = payload.pageCount || 0
      newState.paginatedPlacesData.placesCount = payload.placesCount || 0
      newState.paginatedPlacesData.places = payload.places || []

      return newState
    },
    [FETCH_SCAFFOLD_DATA]: startLoading,
    [FETCH_SCAFFOLD_DATA_FAILURE]: loadingError,
    [FETCH_SCAFFOLD_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      scaffoldData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_STATS]: startLoading,
    [FETCH_STATS_FAILURE]: loadingError,
    [FETCH_STATS_SUCCESS]: (state, { payload }) => ({
      ...state,
      statsData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SUPPLIER]: startLoading,
    [FETCH_SUPPLIER_FAILURE]: loadingError,
    [FETCH_SUPPLIER_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleSupplierData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SUPPLIERS]: startLoading,
    [FETCH_SUPPLIERS_FAILURE]: loadingError,
    [FETCH_SUPPLIERS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedSuppliersData.suppliersPageCount = payload.pageCount || 0
      newState.paginatedSuppliersData.suppliersCount = payload.suppliersCount || 0
      newState.paginatedSuppliersData.suppliers = payload.suppliers || []

      return newState
    },
    [FETCH_TIMEKEEPERS]: startLoading,
    [FETCH_TIMEKEEPERS_FAILURE]: loadingError,
    [FETCH_TIMEKEEPERS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isError: false,
      isLoading: false,
      hasSubmitted: false,
      isSuccess: true,
      errorMessage: null,
      timekeepersData: payload
    }),
    [FETCH_WARD]: startLoading,
    [FETCH_WARD_FAILURE]: loadingError,
    [FETCH_WARD_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleWardData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_WARDS]: startLoading,
    [FETCH_WARDS_FAILURE]: loadingError,
    [FETCH_WARDS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedWardsData.wardsPageCount = 1
      newState.paginatedWardsData.wardsCount = payload.length
      newState.paginatedWardsData.wards = payload || []

      return newState
    },
    [FETCH_WORKSITE]: startLoading,
    [FETCH_WORKSITE_FAILURE]: loadingError,
    [FETCH_WORKSITE_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleWorksiteData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_WORKSITES]: startLoading,
    [FETCH_WORKSITES_FAILURE]: loadingError,
    [FETCH_WORKSITES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedWorksitesData.worksitesPageCount = payload.pageCount || 0
      newState.paginatedWorksitesData.worksitesCount = payload.worksitesCount || 0
      newState.paginatedWorksitesData.worksites = payload.worksites || []

      return newState
    },
    [FETCH_WORKSPACE]: startLoading,
    [FETCH_WORKSPACE_FAILURE]: loadingError,
    [FETCH_WORKSPACE_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleWorkspaceData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_WORKSPACES]: startLoading,
    [FETCH_WORKSPACES_FAILURE]: loadingError,
    [FETCH_WORKSPACES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedWorkspacesData.workspacesPageCount = payload.pageCount || 0
      newState.paginatedWorkspacesData.workspacesCount = payload.workspacesCount || 0
      newState.paginatedWorkspacesData.workspaces = payload.workspaces || []

      return newState
    },
    [FETCH_WORKSPACE_PROJECT]: startLoading,
    [FETCH_WORKSPACE_PROJECT_FAILURE]: loadingError,
    [FETCH_WORKSPACE_PROJECT_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleWorkspaceProjectData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_WORKSPACE_PROJECTS]: startLoading,
    [FETCH_WORKSPACE_PROJECTS_FAILURE]: loadingError,
    [FETCH_WORKSPACE_PROJECTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedWorkspaceProjectsData.workspaceProjectsPageCount = payload.pageCount || 0
      newState.paginatedWorkspaceProjectsData.workspaceProjectsCount =
        payload.workspaceProjectsCount || 0
      newState.paginatedWorkspaceProjectsData.workspaceProjects = payload.workspaceProjects || []

      return newState
    },
    [FETCH_PROGRAMS]: startLoading,
    [FETCH_PROGRAMS_FAILURE]: loadingError,
    [FETCH_PROGRAMS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedProgramsData.programsPageCount = payload.pageCount || 0
      newState.paginatedProgramsData.programsCount = payload.programsCount || 0
      newState.paginatedProgramsData.programs = payload.programs || []

      return newState
    },
    [LOGOUT_SUCCESS]: () => initialState,
    [PREPARE_KWANTU_DATA]: startSubmitting,
    [PREPARE_KWANTU_DATA_FAILURE]: loadingError,
    [PREPARE_KWANTU_DATA_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        kwantuAttendanceData: payload.data.kwantuAttendanceData,
        kwantuPaymentsData: payload.data.kwantuPaymentsData,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [IMPORT_KWANTU_DATA]: startSubmitting,
    [IMPORT_KWANTU_DATA_FAILURE]: loadingError,
    [IMPORT_KWANTU_DATA_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [IMPORT_PARTICIPANTS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true,
      hasError: false,
      errorMessage: null,
      importRequestId: null
    }),
    [IMPORT_PARTICIPANTS_FAILURE]: (state, { payload }) => {
      const errorMessage = payload.errorMessage

      return {
        ...state,
        isLoading: false,
        isError: true,
        isSubmitting: false,
        errorMessage: errorMessage.message,
        importRequestId: null
      }
    },
    [IMPORT_PARTICIPANTS_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        importRequestId: payload
      }
    },
    [IMPORT_OUTPUTS]: startSubmitting,
    [IMPORT_OUTPUTS_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      isSubmitting: false,
      errorMessage: payload.message
    }),
    [IMPORT_OUTPUTS_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [PROMOTE_PARTICIPANTS]: startSubmitting,
    [PROMOTE_PARTICIPANTS_FAILURE]: loadingError,
    [PROMOTE_PARTICIPANTS_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [GENERATE_PAYFILE]: startSubmitting,
    [GENERATE_PAYFILE_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      payrollError: payload.message
    }),
    [GENERATE_PAYFILE_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        payrollObject: payload.data,
        isSuccess: true
      }
    },
    [INITIATE_PAYROLL_REQUEST]: startSubmitting,
    [INITIATE_PAYROLL_REQUEST_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      payrollError: payload.message
    }),
    [INITIATE_PAYROLL_REQUEST_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        payrollObject: payload.data,
        isSuccess: true
      }
    },
    [ONBOARD_EMPLOYEE]: startSubmitting,
    [ONBOARD_EMPLOYEE_FAILURE]: loadingError,
    [ONBOARD_EMPLOYEE_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [PROVISION_INDICATOR_OUTCOME]: startSubmitting,
    [PROVISION_INDICATOR_OUTCOME_FAILURE]: loadingError,
    [PROVISION_INDICATOR_OUTCOME_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [REQUEST_AGREEMENT_ZIP]: startSubmitting,
    [REQUEST_AGREEMENT_ZIP_FAILURE]: loadingError,
    [REQUEST_AGREEMENT_ZIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        requestedZipFile: payload.data,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [SEND_OUTCOMES_TRACKING_REMINDER]: startSubmitting,
    [SEND_OUTCOMES_TRACKING_REMINDER_FAILURE]: loadingError,
    [SEND_OUTCOMES_TRACKING_REMINDER_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [SUBMIT_INDICATOR_OUTCOME]: startSubmitting,
    [SUBMIT_INDICATOR_OUTCOME_FAILURE]: loadingError,
    [SUBMIT_INDICATOR_OUTCOME_SUCCESS]: (state, { payload }) => {
      const stateOutputs = state.paginatedOutputsData.outputs || []
      const newState = {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }

      const latestOutputs = stateOutputs.filter(o => {
        const isSameOutput =
          o.output_indicator_id === parseInt(payload.outcome_indicator_id, 10) &&
          o.outcome_encoded_date === payload.outcome_encoded_date
        return !isSameOutput
      })

      latestOutputs.push({
        number_type: payload.number_type,
        output_indicator_id: parseInt(payload.outcome_indicator_id, 10),
        outcome_encoded_date: payload.outcome_encoded_date,
        achieved_amount: payload.achieved_amount,
        output_target: payload.output_target,
        outcome_description: payload.outcome_description
      })

      newState.paginatedOutputsData.outputs = latestOutputs

      return newState
    },
    [UPDATE_AGREEMENT_TEMPLATE]: startSubmitting,
    [UPDATE_AGREEMENT_TEMPLATE_FAILURE]: loadingError,
    [UPDATE_AGREEMENT_TEMPLATE_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_MUNICIPALITY]: (state, { payload }) => {
      const set = state.municipalitiesData || []
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = { set, payload, payloadId, recordUpdated, recordUpdating }

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        municipalitiesData: updatedData
      }
    },
    [UPDATE_MUNICIPALITY_FAILURE]: (state, payload) => ({
      ...state,
      errorMessage: payload ? payload.errorMessage : null,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [UPDATE_MUNICIPALITY_SUCCESS]: (state, { payload }) => {
      const updatedData = state.municipalitiesData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        municipalitiesData: updatedData
      }
    },
    [UPDATE_OUTPUT]: startSubmitting,
    [UPDATE_OUTPUT_FAILURE]: loadingError,
    [UPDATE_OUTPUT_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_OUTPUT_AREA]: startSubmitting,
    [UPDATE_OUTPUT_AREA_FAILURE]: loadingError,
    [UPDATE_OUTPUT_AREA_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_OUTPUT_INDICATOR]: startSubmitting,
    [UPDATE_OUTPUT_INDICATOR_FAILURE]: loadingError,
    [UPDATE_OUTPUT_INDICATOR_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_PLACE]: (state, { payload }) => {
      const set = state.placesData || []
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = { set, payload, payloadId, recordUpdated, recordUpdating }

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        placesData: updatedData
      }
    },
    [UPDATE_PLACE_FAILURE]: (state, payload) => ({
      ...state,
      errorMessage: payload ? payload.errorMessage : null,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [UPDATE_PLACE_SUCCESS]: (state, { payload }) => {
      const updatedData = state.placesData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        placesData: updatedData
      }
    },
    [UPDATE_SUPPLIER]: startSubmitting,
    [UPDATE_SUPPLIER_FAILURE]: loadingError,
    [UPDATE_SUPPLIER_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_WARD]: (state, { payload }) => {
      const set = state.wardsData || []
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = { set, payload, payloadId, recordUpdated, recordUpdating }

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        wardsData: updatedData
      }
    },
    [UPDATE_WARD_FAILURE]: loadingError,
    [UPDATE_WARD_SUCCESS]: (state, { payload }) => {
      const updatedData = state.wardsData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        wardsData: updatedData
      }
    },
    [UPDATE_WORKSITE]: startSubmitting,
    [UPDATE_WORKSITE_FAILURE]: loadingError,
    [UPDATE_WORKSITE_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_WORKSPACE]: startSubmitting,
    [UPDATE_WORKSPACE_FAILURE]: loadingError,
    [UPDATE_WORKSPACE_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [UPDATE_WORKSPACE_PROJECT]: startSubmitting,
    [UPDATE_WORKSPACE_PROJECT_FAILURE]: loadingError,
    [UPDATE_WORKSPACE_PROJECT_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [DOWNLOAD_BULK_AGREEMENTS]: startSubmitting,
    [DOWNLOAD_BULK_AGREEMENTS_FAILURE]: loadingError,
    [DOWNLOAD_BULK_AGREEMENTS_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [BULK_REGENERATE_AGREEMENTS]: startSubmitting,
    [BULK_REGENERATE_AGREEMENTS_FAILURE]: loadingError,
    [BULK_REGENERATE_AGREEMENTS_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [BULK_UPLOAD_DOCUMENTS]: startSubmitting,
    [BULK_UPLOAD_DOCUMENTS_FAILURE]: loadingError,
    [BULK_UPLOAD_DOCUMENTS_SUCCESS]: (state, { payload }) => ({
      ...state,
      bulkDocumentUpload: payload,
      bulkDocumentUploadStatus: null,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true
    }),
    [FETCH_BULK_DOCUMENT_UPLOAD_STATUS]: state => state,
    [FETCH_BULK_DOCUMENT_UPLOAD_STATUS_FAILURE]: loadingError,
    [FETCH_BULK_DOCUMENT_UPLOAD_STATUS_SUCCESS]: (state, { payload }) => ({
      ...state,
      bulkDocumentUploadStatus: payload
    }),
    [RESET_BULK_DOCUMENT_UPLOAD]: state => ({
      ...state,
      bulkDocumentUpload: null,
      bulkDocumentUploadStatus: null,
      errorMessage: null,
      isError: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [BULK_REGENERATE_ARCHIVES]: startSubmitting,
    [BULK_REGENERATE_ARCHIVES_FAILURE]: loadingError,
    [BULK_REGENERATE_ARCHIVES_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [BULK_REGENERATE_PAYSLIPS]: startSubmitting,
    [BULK_REGENERATE_PAYSLIPS_FAILURE]: loadingError,
    [BULK_REGENERATE_PAYSLIPS_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [FETCH_PARTICIPANT_PROFILE]: startLoading,
    [FETCH_PARTICIPANT_PROFILE_FAILURE]: loadingError,
    [FETCH_PARTICIPANT_PROFILE_SUCCESS]: (state, { payload }) => ({
      ...state,
      participantProfile: payload,
      isLoading: false,
      isError: false
    })
  },
  initialState
)
